{
  "de": {
    "lead": {
      "actions": {
        "add_company": "Organisation hinzufügen",
        "add_lead": "Lead hinzufügen",
        "new": "Lead"
      },
      "attributes": {
        "address": "Adresse",
        "birth_date": "Geburtsdatum",
        "categories": {
          "enduser": "Eigennutzer",
          "investor": "Investor"
        },
        "category": "Lead-Typ",
        "company_name": "Organisationsname",
        "company_vat": "USt-IdNr.",
        "email_address": "E-Mail",
        "first_name": "Vorname",
        "iban": "IBAN",
        "internal_note": "Interne Notiz",
        "language": "Sprache",
        "last_name": "Nachname",
        "phone_landline": "Festnetznummer",
        "phone_mobile": "Mobilnummer",
        "status": "Status"
      },
      "labels": {
        "detailed_information": "Detaillierte Informationen eingeben",
        "lead": "Lead"
      },
      "validation": {
        "needFirstName": "Vorname erforderlich",
        "needLastName": "Nachname erforderlich"
      }
    }
  }
}
